module.exports = __webpack_public_path__ + "static/media/menu_dropdown_black.a2329994.svg";